import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var genBorderedStyle = function genBorderedStyle(token) {
  var _table, _ref4, _extends2, _ref6, _ref7;
  var componentCls = token.componentCls;
  var tableBorder = token.lineWidth + "px " + token.lineType + " " + token.tableBorderColor;
  var getSizeBorderStyle = function getSizeBorderStyle(size, paddingVertical, paddingHorizontal) {
    return _defineProperty({}, "&" + componentCls + "-" + size, _defineProperty({}, "> " + componentCls + "-container", _defineProperty({}, "> " + componentCls + "-content, > " + componentCls + "-body", {
      '> table > tbody > tr > td': _defineProperty({}, "> " + componentCls + "-expanded-row-fixed", {
        margin: "-" + paddingVertical + "px -" + (paddingHorizontal + token.lineWidth) + "px"
      })
    })));
  };
  return _defineProperty({}, componentCls + "-wrapper", (_ref7 = {}, _defineProperty(_ref7, "" + componentCls + componentCls + "-bordered", _extends(_extends(_extends((_extends2 = {}, _defineProperty(_extends2, "> " + componentCls + "-title", {
    border: tableBorder,
    borderBottom: 0
  }), _defineProperty(_extends2, "> " + componentCls + "-container", (_ref4 = {
    borderInlineStart: tableBorder
  }, _defineProperty(_ref4, "\n            > " + componentCls + "-content,\n            > " + componentCls + "-header,\n            > " + componentCls + "-body,\n            > " + componentCls + "-summary\n          ", {
    '> table': (_table = {}, _defineProperty(_table, "\n                > thead > tr > th,\n                > tbody > tr > td,\n                > tfoot > tr > th,\n                > tfoot > tr > td\n              ", {
      borderInlineEnd: tableBorder
    }), _defineProperty(_table, '> thead', {
      '> tr:not(:last-child) > th': {
        borderBottom: tableBorder
      },
      '> tr > th::before': {
        backgroundColor: 'transparent !important'
      }
    }), _defineProperty(_table, "\n                > thead > tr,\n                > tbody > tr,\n                > tfoot > tr\n              ", _defineProperty({}, "> " + componentCls + "-cell-fix-right-first::after", {
      borderInlineEnd: tableBorder
    })), _defineProperty(_table, '> table > tbody > tr > td', _defineProperty({}, "> " + componentCls + "-expanded-row-fixed", {
      margin: "-" + token.tablePaddingVertical + "px -" + (token.tablePaddingHorizontal + token.lineWidth) + "px",
      '&::after': {
        position: 'absolute',
        top: 0,
        insetInlineEnd: token.lineWidth,
        bottom: 0,
        borderInlineEnd: tableBorder,
        content: '""'
      }
    })), _table)
  }), _defineProperty(_ref4, "\n            > " + componentCls + "-content,\n            > " + componentCls + "-header\n          ", {
    '> table': {
      borderTop: tableBorder
    }
  }), _ref4)), _defineProperty(_extends2, "&" + componentCls + "-scroll-horizontal", _defineProperty({}, "> " + componentCls + "-container > " + componentCls + "-body", {
    '> table > tbody': _defineProperty({}, "\n                > tr" + componentCls + "-expanded-row,\n                > tr" + componentCls + "-placeholder\n              ", {
      '> td': {
        borderInlineEnd: 0
      }
    })
  })), _extends2), getSizeBorderStyle('middle', token.tablePaddingVerticalMiddle, token.tablePaddingHorizontalMiddle)), getSizeBorderStyle('small', token.tablePaddingVerticalSmall, token.tablePaddingHorizontalSmall)), _defineProperty({}, "> " + componentCls + "-footer", {
    border: tableBorder,
    borderTop: 0
  }))), _defineProperty(_ref7, componentCls + "-cell", (_ref6 = {}, _defineProperty(_ref6, componentCls + "-container:first-child", {
    // :first-child to avoid the case when bordered and title is set
    borderTop: 0
  }), _defineProperty(_ref6, '&-scrollbar:not([rowspan])', {
    boxShadow: "0 " + token.lineWidth + "px 0 " + token.lineWidth + "px " + token.tableHeaderBg
  }), _ref6)), _ref7));
};
export default genBorderedStyle;